import { render, staticRenderFns } from "./error-nav.vue?vue&type=template&id=3baec99a&scoped=true&"
import script from "./error-nav.vue?vue&type=script&lang=js&"
export * from "./error-nav.vue?vue&type=script&lang=js&"
import style0 from "./error-nav.vue?vue&type=style&index=0&id=3baec99a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baec99a",
  null
  
)

export default component.exports